<template>
  <div>
    <el-table
      :data="tableData"
      border
      :cell-style="{ padding: '10px 0' }"
      style="width: 100%">
      <el-table-column
        prop="warningSource"
        label="报警来源"
        width="180">
      </el-table-column>
      <el-table-column
        label="来源类型"
        width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.sourceType | filter1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pointNo"
        label="定位器编号">
      </el-table-column>
      <el-table-column
        label="报警原因">
        <template slot-scope="scope">
          <span>{{ scope.row.warningReason | filter2 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="warningArea"
        label="报警区域">
      </el-table-column>
      <el-table-column
        prop="warningNum"
        label="报警数">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <el-tag effect="plain" type="danger" size="small" v-if="scope.row.warningStatus === 0">未处理</el-tag>
          <el-tag effect="plain" type="success" size="small" v-if="scope.row.warningStatus === 1">已处理</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <span class="operationBtn" @click="open(scope.row.id)" v-if="hendleResult(scope.row)">处理</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="personnelPage">
      <el-pagination
        background
        layout="prev, pager, next" :current-page="curPage"
        :total="total" :page-size="limit" @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getPersonWarningList, handlePersonWarning } from "@/api/earlyWarning"
export default {
  name: 'personnel',
  data() {
    return {
      tableData: [],
      total: 0,
      curPage: 1,
      limit: 10,
    }
  },
  // 过滤器
  filters: {
    filter1(val) {
      let arr = [
        { id: 0, type: '员工' },{ id: 1, type: '访客' },
        { id: 2, type: '承包商' },{ id: 4, type: '区域超员' },
        { id: 5, type: '电子围栏超员' },{ id: 20, type: '员工' },
        { id: 21, type: '访客' },{ id: 22, type: '承包商' },
        { id: 23, type: '物品' },{ id: 24, type: '车辆' },
        { id: 25, type: '司机' },
      ]
      let str = ''
      for(let i in arr) {
        if(arr[i].id === val){
          str = arr[i].type
        }
      }
      return str
    },
    filter2(val) {
      let arr2 = [
        { id: 1, name: '进入禁区' },{ id: 2, name: '车间超员' },
        { id: 3, name: '进入车间超时' },{ id: 4, name: '进入车间未达标' },
        { id: 5, name: '进入车间静止时间太长' },{ id: 6, name: '紧急报警' },
        { id: 7, name: '电子围栏:时间过长' },{ id: 8, name: '电子围栏:时间过短' },
        { id: 9, name: '电子围栏:静止过长' },{ id: 10, name: '电子围栏:人数超员' },
        { id: 11, name: '操作工超员' }
      ]
      let str = ''
      for(let i in arr2) {
        if(arr2[i].id == val){
          str = arr2[i].name
          return str = arr2[i].name
        }else{
          str = val
        }
      }
      return str
    },
  },
  methods:{
    // 判断能不能被处理
    hendleResult(val) {
      if(val.warningReason.length > 3){
        return false
      }else{
        if(val.warningStatus === 1) {
          return false
        }else{
          return true
        }
      }
    },
    open(val) {
      this.$prompt('请输入处理结果', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        handlePersonWarning({ disposeResult: value, id: val }).then(res => {
          this.$message({
            type: 'success',
            message: '你的处理结果是: ' + value
          });
          this.getList()
        })
      }).catch(() => {
        return  
      });
    },
    pageChange(val) {
      this.curPage = val
      this.getList()
    },
    getList(){
      getPersonWarningList({curPage: this.curPage, limit: this.limit}).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
  .operationBtn {
    cursor: pointer;
    color: rgb(41,140,246)
  }
  .personnelPage{
    text-align: right;
    margin-top: 15px
  }
</style>